
import React, { useState, useEffect } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./select";
import { format, parse, isValid } from "date-fns";

interface TimePickerProps {
  value: Date;
  onChange: (date: Date) => void;
  disabled?: boolean;
  interval?: 5 | 10 | 15 | 30 | 60; // Perc intervallum az opciókhoz
}

export const TimePicker: React.FC<TimePickerProps> = ({ 
  value, 
  onChange, 
  disabled = false,
  interval = 15 // Alapértelmezett 15 perces intervallum
}) => {
  const [timeValue, setTimeValue] = useState(format(value, "HH:mm"));

  // Generate time options with the specified interval
  const timeOptions = [];
  for (let hour = 0; hour < 24; hour++) {
    for (let minute = 0; minute < 60; minute += interval) {
      const formattedHour = hour.toString().padStart(2, "0");
      const formattedMinute = minute.toString().padStart(2, "0");
      timeOptions.push(`${formattedHour}:${formattedMinute}`);
    }
  }

  useEffect(() => {
    if (value && isValid(value)) {
      setTimeValue(format(value, "HH:mm"));
    }
  }, [value]);

  const handleTimeChange = (newTime: string) => {
    setTimeValue(newTime);
    const parsedTime = parse(newTime, "HH:mm", new Date());

    if (isValid(parsedTime)) {
      const newDate = new Date(value);
      newDate.setHours(parsedTime.getHours());
      newDate.setMinutes(parsedTime.getMinutes());
      onChange(newDate);
    }
  };

  return (
    <Select
      value={timeValue}
      onValueChange={handleTimeChange}
      disabled={disabled}
    >
      <SelectTrigger className="w-full">
        <SelectValue placeholder="Időpont kiválasztása" />
      </SelectTrigger>
      <SelectContent>
        {timeOptions.map((time) => (
          <SelectItem key={time} value={time}>
            {time}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
